import type { ReactElement } from "react";

import { Tooltip } from "@similarweb/ui-components";
import { Flex } from "@similarweb/ui-components/foundations";

import { useCrmManagementReadOnly } from "app/pages/sales-intelligence/hooks/useCrmManagementReadOnly";

interface ICrmManagementDisabledTooltipProps {
    readonly renderContent: (isReadOnly: boolean) => ReactElement;
}

export const CrmManagementDisabledTooltip = ({ renderContent }: ICrmManagementDisabledTooltipProps): ReactElement => {
    const { isReadOnly, disabledTooltip } = useCrmManagementReadOnly();
    const content = renderContent(isReadOnly);

    if (!isReadOnly) {
        return content;
    }

    return (
        <Tooltip
            content={disabledTooltip}
            placement="top"
            enabled
        >
            <Flex inline>{content}</Flex>
        </Tooltip>
    );
};
